import Vue from 'vue';
import VueI18n from 'vue-i18n';
import KEYS from '@/values/keys';
import i18nGlobal from '@/lang/i18n';
import { aboutUsI18n } from '@/app/public/about-us/lang/about-us.i18n';
import { homeI18n } from '@/app/public/home/lang/home.i18n';
import { authI18n } from '@/auth/lang/auth.i18n';
import { toolsI18n } from '@/tools/lang/tools.i18n';
import { myContentI18n } from '@/app/private/my-content/lang/my-content.i18n';
import { commonI18n } from './common.i18n';
import { calendarI18n } from './calendar.i18n'
import { coursesI18n } from '@/courses/lang/courses.i18n';
import { meetingsI18n } from '@/meetings/lang/meetings.i18n';
import { bookstoreI18n } from '@/app/private/bookstore/lang/bookstore.i18n';
import { courseTemplatesI18n } from '@/course-templates/lang/course-templates.i18n';
import { classesI18n } from '@/classes/lang/classes.i18n';
import { screenMirroringI18n } from '@/screen-mirroring/lang/screen-mirroring.i18n';
import { portalI18n } from '@/app/private/portal/lang/portal.i18n';
import { userRequestsI18n } from '@/app/private/user-requests/lang/user-requests.i18n';
import { LocalStorageService } from '@/services/local-storage.service';
import { APP_STORAGE_KEYS } from '../enums/app.enum';
import { sectionsI18n } from '@/sections/lang/sections.i18n';
import { designerI18n } from '@/components/designer/designer.i18n';

Vue.use(VueI18n);

export const messages = {
  en: {
    common: commonI18n.en,
    auth: authI18n.en,
    about: aboutUsI18n.en,
    bookstore: bookstoreI18n.en,
    home: homeI18n.en,
    tools: toolsI18n.en,
    myContent: myContentI18n.en,
    calendar: calendarI18n.en,
    courses: coursesI18n.en,
    meetings: meetingsI18n.en,
    courseTemplates: courseTemplatesI18n.en,
    language: {
      spanish: 'Spanish',
      english: 'English'
    },
    inactivityTimeout: i18nGlobal.en.inactivityTimeout,
    footer: i18nGlobal.en.footer,
    errors: i18nGlobal.en.errors,
    menu: i18nGlobal.en.menu,
    breadcrumbs: i18nGlobal.en.breadcrumbs,
    viewer: meetingsI18n.en.viewer,
    classes: classesI18n.en,
    lesson: coursesI18n.en.lesson,
    deck: coursesI18n.en.deck,
    subdeck:  coursesI18n.en.subdeck,
    homeworks: i18nGlobal.en.homeworks,
    teacherPortal: i18nGlobal.en.teacherPortal, 
    screenMirroring: screenMirroringI18n.en,
    portal: portalI18n.en,
    edupad: i18nGlobal.en.edupad,
    drawItems: i18nGlobal.en.drawItems,
    userRequests: userRequestsI18n.en,
    error404: i18nGlobal.en.error404,
    sections: sectionsI18n.en,
    designer: designerI18n.en,
    updateApp: i18nGlobal.en.updateApp
  },
  es: {
    common: commonI18n.es,
    auth: authI18n.es,
    about: aboutUsI18n.es,
    bookstore: bookstoreI18n.es,
    home: homeI18n.es,
    tools: toolsI18n.es,
    myContent: myContentI18n.es,
    calendar: calendarI18n.es,
    courses: coursesI18n.es,
    meetings: meetingsI18n.es,
    courseTemplates: courseTemplatesI18n.es,
    language: {
      spanish: 'Español',
      english: 'Inglés'
    },
    inactivityTimeout: i18nGlobal.es.inactivityTimeout,
    footer: i18nGlobal.es.footer,
    errors: i18nGlobal.es.errors,
    menu: i18nGlobal.es.menu,
    breadcrumbs: i18nGlobal.es.breadcrumbs,
    viewer: meetingsI18n.es.viewer,
    classes: classesI18n.es,
    lesson: coursesI18n.es.lesson,
    deck: coursesI18n.es.deck,
    subdeck:  coursesI18n.es.subdeck,
    homeworks: i18nGlobal.es.homeworks,
    teacherPortal: i18nGlobal.es.teacherPortal,
    screenMirroring: screenMirroringI18n.es,
    portal: portalI18n.es,
    edupad: i18nGlobal.es.edupad,
    drawItems: i18nGlobal.es.drawItems,
    userRequests: userRequestsI18n.es,
    error404: i18nGlobal.es.error404,
    sections: sectionsI18n.es,
    designer: designerI18n.es,
    updateApp: i18nGlobal.es.updateApp
  }
};

export const i18n = new VueI18n({
  locale: LocalStorageService.getItem(APP_STORAGE_KEYS.ED_LANGUAGE_SELECTED) || KEYS.LANGUAGES.EN,
  messages: messages
});
